var map = {
	"./Tamilnadu-Assembly-NEW.svg": 178,
	"./action.svg": 207,
	"./adventure.svg": 208,
	"./advertorial.svg": 209,
	"./ai.svg": 210,
	"./album.svg": 211,
	"./analysis.svg": 212,
	"./anchor.svg": 213,
	"./android-block.svg": 214,
	"./android-small.svg": 215,
	"./android.svg": 216,
	"./angle-down.svg": 217,
	"./angle-left.svg": 218,
	"./angle-right.svg": 219,
	"./angle-up.svg": 220,
	"./aquarius.svg": 221,
	"./arcade.svg": 222,
	"./aries.svg": 223,
	"./arrow-down.svg": 224,
	"./arrow-left.svg": 225,
	"./arrow-right.svg": 226,
	"./arrow-up.svg": 227,
	"./arrow.svg": 228,
	"./art-director.svg": 229,
	"./astrology.svg": 230,
	"./author-avator.svg": 231,
	"./author.svg": 232,
	"./authoranchor.svg": 233,
	"./authorwhite.svg": 234,
	"./automobile.svg": 235,
	"./backward.svg": 236,
	"./bookmark.svg": 237,
	"./books-vikatan.svg": 238,
	"./brandconnect.svg": 239,
	"./breaking-news.svg": 240,
	"./bullet-arrow.svg": 241,
	"./bundle.svg": 242,
	"./business.svg": 243,
	"./calendar.svg": 244,
	"./cancel.svg": 245,
	"./cancer.svg": 246,
	"./canvas.svg": 247,
	"./capricorn.svg": 248,
	"./cartoonist.svg": 249,
	"./cinema.svg": 250,
	"./clapboard.svg": 251,
	"./clipboard.svg": 252,
	"./close.svg": 253,
	"./comment.svg": 254,
	"./corona-updates-icon.svg": 255,
	"./creative-director.svg": 256,
	"./cricket.svg": 257,
	"./crime.svg": 258,
	"./data.svg": 259,
	"./designed.svg": 260,
	"./double-arrow.svg": 261,
	"./downarrow.svg": 262,
	"./download.svg": 263,
	"./edit.svg": 264,
	"./edited-by.svg": 265,
	"./election-2026.svg": 266,
	"./email.svg": 267,
	"./environment.svg": 268,
	"./exclusivedeals.svg": 269,
	"./facebook-bg.svg": 270,
	"./facebook-icon.svg": 271,
	"./facebook.svg": 272,
	"./filter-icon.svg": 273,
	"./filter.svg": 274,
	"./food-stylist.svg": 275,
	"./forward.svg": 276,
	"./gallery.svg": 277,
	"./game-shop.svg": 278,
	"./gemini.svg": 279,
	"./group.svg": 280,
	"./gzhome.svg": 281,
	"./gzsports.svg": 282,
	"./gztrending.svg": 283,
	"./health.svg": 284,
	"./hexbackground.svg": 285,
	"./home.svg": 286,
	"./humoursatire-entertainment.svg": 287,
	"./icon-apple.svg": 288,
	"./icon-appstore.svg": 289,
	"./icon-audio-app-store.svg": 290,
	"./icon-audio-fb.svg": 291,
	"./icon-audio-instagram.svg": 292,
	"./icon-audio-next.svg": 293,
	"./icon-audio-play-store.svg": 294,
	"./icon-audio-previous.svg": 295,
	"./icon-audio-twitter.svg": 296,
	"./icon-audio-whatsapp.svg": 297,
	"./icon-comments-share.svg": 298,
	"./icon-copy.svg": 299,
	"./icon-election.svg": 300,
	"./icon-episode.svg": 301,
	"./icon-facebook.svg": 302,
	"./icon-google-play.svg": 303,
	"./icon-headset.svg": 304,
	"./icon-home-plus.svg": 305,
	"./icon-login.svg": 306,
	"./icon-open-in-new.svg": 307,
	"./icon-pause.svg": 308,
	"./icon-play.svg": 309,
	"./icon-playstore.svg": 310,
	"./icon-premium.svg": 311,
	"./icon-share.svg": 312,
	"./icon-star.svg": 313,
	"./icon-timer.svg": 314,
	"./icon-twitter.svg": 315,
	"./icon-user.svg": 316,
	"./icon-video.svg": 317,
	"./icon-whatsapp.svg": 318,
	"./illustrator-t1.svg": 319,
	"./illustrator.svg": 320,
	"./infographer.svg": 321,
	"./instagram.svg": 322,
	"./interviews.svg": 323,
	"./ios-block.svg": 324,
	"./ios-small.svg": 325,
	"./ios.svg": 326,
	"./jokes.svg": 327,
	"./leo.svg": 328,
	"./libra.svg": 329,
	"./lifestyle.svg": 330,
	"./like.svg": 331,
	"./line-arrow-next.svg": 332,
	"./line-arrow-prev.svg": 333,
	"./linkedin.svg": 334,
	"./listicle.svg": 335,
	"./live-chat.svg": 336,
	"./liveupdate.svg": 337,
	"./log green.svg": 338,
	"./log grey.svg": 339,
	"./log white.svg": 340,
	"./logic.svg": 341,
	"./login-facebook.svg": 342,
	"./login-google.svg": 343,
	"./login.svg": 344,
	"./logout-mobile.svg": 345,
	"./logout.svg": 346,
	"./longform.svg": 347,
	"./magazines.svg": 348,
	"./mail.svg": 349,
	"./menu-search.svg": 350,
	"./microphone.svg": 351,
	"./minus.svg": 352,
	"./mobile-share.svg": 353,
	"./moderated.svg": 354,
	"./more-outline.svg": 355,
	"./my-vikatan-logo.svg": 356,
	"./mynews.svg": 357,
	"./myvikatanbadge.svg": 358,
	"./narrated.svg": 359,
	"./news.svg": 360,
	"./newsletter.svg": 361,
	"./newslettericon.svg": 362,
	"./olympic.svg": 363,
	"./online-news.svg": 364,
	"./pause.svg": 365,
	"./pdf.svg": 366,
	"./pen.svg": 367,
	"./personalise.svg": 368,
	"./phone.svg": 369,
	"./photo.svg": 370,
	"./photographer.svg": 371,
	"./photostory.svg": 372,
	"./pisces.svg": 373,
	"./play.svg": 374,
	"./plus.svg": 375,
	"./podcast.svg": 376,
	"./podcast_vikatan_menu.svg": 377,
	"./poems.svg": 378,
	"./politics.svg": 379,
	"./premium.svg": 380,
	"./producer.svg": 381,
	"./proofread.svg": 382,
	"./published-by.svg": 383,
	"./published.svg": 384,
	"./rain.svg": 385,
	"./rss.svg": 386,
	"./rupee.svg": 387,
	"./sagitarius.svg": 388,
	"./scorpio.svg": 389,
	"./script-writer.svg": 390,
	"./scripted.svg": 391,
	"./search.svg": 392,
	"./share-alt.svg": 393,
	"./share.svg": 394,
	"./sharechat.svg": 395,
	"./shortform.svg": 396,
	"./shortstories.svg": 397,
	"./shortvideo.svg": 398,
	"./slider-next.svg": 399,
	"./slider-prev.svg": 400,
	"./socialshare.svg": 401,
	"./sort.svg": 402,
	"./sound.svg": 403,
	"./speaker.svg": 404,
	"./speakeraudio.svg": 405,
	"./spiritual.svg": 406,
	"./sponsored.svg": 407,
	"./sports.svg": 408,
	"./star.svg": 409,
	"./stories.svg": 410,
	"./strategy.svg": 411,
	"./stylist.svg": 412,
	"./subscribe-vikatan.svg": 413,
	"./success-icon.svg": 414,
	"./tag.svg": 415,
	"./tamilnadu.svg": 416,
	"./taurus.svg": 417,
	"./technology.svg": 418,
	"./text.svg": 419,
	"./textsms.svg": 420,
	"./thodargal.svg": 421,
	"./thump.svg": 422,
	"./tick.svg": 423,
	"./trending.svg": 424,
	"./twitter-icon.svg": 425,
	"./twitter.svg": 426,
	"./unlike.svg": 427,
	"./uparrow.svg": 428,
	"./update-black.svg": 429,
	"./user-square.svg": 430,
	"./user.svg": 431,
	"./v-plus-logo.svg": 432,
	"./video-editor.svg": 433,
	"./video-icon.svg": 434,
	"./video-play.svg": 435,
	"./video.svg": 436,
	"./videographer.svg": 437,
	"./vikatan-play-logo-red.svg": 438,
	"./vikatan-play.svg": 439,
	"./vikatan-tv.svg": 440,
	"./vikatan.svg": 441,
	"./vikatanconnect.svg": 442,
	"./vikatanplay.svg": 443,
	"./vikatanspl.svg": 444,
	"./vikatantv.svg": 445,
	"./virgo.svg": 446,
	"./whatsapp-icon.svg": 447,
	"./whatsapp-icon1.svg": 448,
	"./whatsapp.svg": 449,
	"./women-home.svg": 450,
	"./writtenarticles.svg": 451,
	"./writtenstory.svg": 452,
	"./youtube.svg": 453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;